import React from 'react'
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import YearPresetRangeDatePickers from "../global/Table/TablePageHelpers/YearPresetRangeDatePickers";
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Chip from "@material-ui/core/Chip";
import './InvoiceFiltersDialog.css';

const ROW_FIELD_WIDTH = 220
const ROW_WIDTH = ROW_FIELD_WIDTH * 2 + 12 // two fields plus the row's column gap

class InvoiceFiltersDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    // Applying on Enter keeps the text filters usable without reaching for the Apply button
    onTextFilterKeyDown = (event) => {
        if (event.key === 'Enter') {
            this.props.onClose(true, true)
        }
    }

    renderTextFilter = (fieldName, label) => (
        <TextField
            label={label}
            name={fieldName}
            value={this.props.filtersMap?.[fieldName] ?? ''}
            onChange={(event) => this.props.onTextFilterChange(fieldName, event.target.value)}
            onKeyDown={this.onTextFilterKeyDown}
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            style={{ width: ROW_FIELD_WIDTH, marginBottom: 20 }}
        />
    )

    render() {
        // Only the supplier invoices table opts into the PO Number / Reference Id filters, the carrier
        // and FTL carrier invoice tables reuse this dialog with the original single column layout.
        const showTextFilters = !!this.props.showTextFilters
        return (
            <>
                <div>
                    <DialogTitle id="form-dialog-title" style={{ width: "70%", display: "flex", justifyContent: "center" }}>
                        Filters
                    </DialogTitle>
                    <DialogContent className={"dialogBox"}>
                        <Autocomplete
                            multiple
                            open={this.state.open}
                            value={this.props.filtersMap?.carriers ?? this.props.filtersMap?.suppliers ?? []}
                            options={this.props.listItems?.sort((a, b) => {
                                return a.toLowerCase().localeCompare(b.toLowerCase())
                            })}
                            renderTags={(value) =>
                                value.map((option) => (
                                    <Chip
                                        variant="outlined"
                                        size="small"
                                        style={{borderColor: "#acd685", margin: "1px 6px 1px 0", fontSize: "12px"}}
                                        label={option}
                                    />
                                ))
                            }
                            getOptionLabel={(entry) => entry}
                            autoHighlight={true}
                            style={{ width: showTextFilters ? ROW_WIDTH : 350, margin: 10, marginBottom: 20 }}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <Checkbox
                                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                    />
                                    {option}
                                </React.Fragment>
                            )}
                            onOpen={(event) => {this.setState({open : true})}}
                            onClose={(event, reason) => {
                                reason === 'blur' ? this.setState({open : false}) : this.setState({open : true})
                            }}
                            name={this.props.fieldName}
                            onChange={(event, value) => {
                                this.props.onChange(this.props.fieldName, value)
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label={this.props.fieldTitle}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    name={this.props.fieldName}
                                />
                            }
                        />
                        {showTextFilters &&
                            <div className="invoice-filters-row">
                                {this.renderTextFilter('poNumber', 'PO Number')}
                                {this.renderTextFilter('referenceId', 'Reference Id')}
                            </div>
                        }
                        {showTextFilters ?
                            <div className="invoice-filters-row">
                                <YearPresetRangeDatePickers
                                    fromValue={this.props.fromDate}
                                    toValue={this.props.toDate}
                                    width={ROW_FIELD_WIDTH}
                                    onFromChange={(date) => this.props.handleDateChange(date, 'fromDate')}
                                    onToChange={(date) => {
                                        date.setHours(19);
                                        date.setMinutes(59);
                                        date.setSeconds(59);
                                        this.props.handleDateChange(date, 'toDate')
                                    }}
                                />
                            </div>
                            :
                            <YearPresetRangeDatePickers
                                fromValue={this.props.fromDate}
                                toValue={this.props.toDate}
                                width={350}
                                onFromChange={(date) => this.props.handleDateChange(date, 'fromDate')}
                                onToChange={(date) => {
                                    date.setHours(19);
                                    date.setMinutes(59);
                                    date.setSeconds(59);
                                    this.props.handleDateChange(date, 'toDate')
                                }}
                            />
                        }
                    </DialogContent>

                    <DialogActions style={{ justifyContent: "center", marginBottom: 10 }}>
                        <Button variant='contained' onClick={() => this.props.onClose(false, true)}>Cancel</Button>
                        <Button variant='contained' onClick={() => {
                            this.props.onClose(true, true)
                        }} color="primary">Apply</Button>
                    </DialogActions>

                </div>
            </>
        )
    }
}

export default InvoiceFiltersDialog;